'use client';

import clarity from '@microsoft/clarity';
import { useEffect } from 'react';

export function ClarityAnalytics() {
  useEffect(() => {
    // Only initialize Clarity in production environments (not on localhost)
    if (typeof window !== 'undefined' && 
        !window.location.hostname.includes('localhost') && 
        !window.location.hostname.includes('127.0.0.1')) {
      // Initialize Clarity with your project ID from environment variable
      const clarityProjectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID;
      if (clarityProjectId) {
        clarity.init(clarityProjectId);
      } else {
        console.error('Clarity project ID is not defined in environment variables');
      }
    }
  }, []);

  // This component doesn't render anything
  return null;
}
